import React, { useEffect, useState, Fragment } from 'react'
import { Modal, Input, Row, Table, Tag } from 'antd'
import moment from 'moment'
import { queryClinicCombo } from '@/services/order';
import styles from './index.less'
import { CLINIC_KEY, HTTP_SUCCESS_CODE } from '@/utils/consts';
import ProductCategoryTreeSelect from "@/components/ProductCategoryTreeSelect";

const { Search } = Input;

const PAGE_SIZE = 10;

const ProductModal = ({ onOk, onOpenDetail, productCategories, clinicId, ...modalProps }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(() => ({ current: 1, pageSize: PAGE_SIZE, total: 0 }));
  const [category, setCategory] = useState(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [combo, setCombo] = useState([])

  useEffect(() => {
    fetchClinicComboList(pagination.current, category);
  }, [pagination.current, category]);

  const fetchClinicComboList = async (pageNo, category, name) => {
    setLoading(true);
    const res = await queryClinicCombo({ searchName:name, categoryId:category ,pageNo, pageSize: PAGE_SIZE, enable: true, clinicId:window.localStorage.getItem(CLINIC_KEY) });
    setLoading(false);

    if (!res || res.code !== HTTP_SUCCESS_CODE) return;

    const { content, totalCount } = res.data;
    setCombo(content);
    // setPagination(prevState => ({ ...prevState, pageNo, total: totalCount }));
    // const rowKeys = rows.reduce((prev, current) => {
    //   if (selectedRows.find(_ => _.id === current.id)) {
    //     prev.push(current.id);
    //   }

    //   return prev;
    // }, []);
    // setSelectedRowKeys(rowKeys);
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
    setPagination(prevState => ({ ...prevState, current: 1 }))
  };

  const handleOk = () => {
    onOk(products);
  };

  const handleSearchName = (val) => {
    fetchClinicComboList(1, category, val);
  };

  const handlePageChange = (pageNo) => {
    setPagination(prevState => ({ ...prevState, current: pageNo }))
  };

  const handleRemove = (row) => {
    setSelectedRowKeys(prevRowKeys => prevRowKeys.filter(_ => _ !== row.id));
    setSelectedRows(prevSelectedRows => prevSelectedRows.filter(_ => _.id !== row.id));
  };

  const columns = [
    {
      key: 'categoryList',
      title: '商品类别',
      width: 100,
      render: (_, record) => (record.categoryList || []).map(_ => _.name).join("/")

    },
    {
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      dataIndex: 'product',
      title: '价格',
      width: 80,
      render(text, record) {
        return text && text.price
      }
    },
    {
      dataIndex: 'quantity',
      title: '数量',
      width: 80,
      render(text, record) {
        return text
      }
    },
    {
      key: 'serviceDuration',
      title: '服务时长',
      width: 70,
      align: 'right',
      render: (_, record) => {
        if (!record.product) return null;

        const { serviceDuration, unit } = record.product;

        return (serviceDuration || '') + (unit || '');
      }
    },
    // {
    //   dataIndex: 'productAt',
    //   title: '发布时间',
    //   width: 100,
    //   render(text) {
    //     return moment(text).format('YYYY-MM-DD')
    //   }
    // },
    // {
    //   dataIndex: 'operation',
    //   title: '操作',
    //   width: 70,
    //   align: 'center',
    //   render(text, record) {
    //     return <Fragment>
    //       <a href="javascript:void(0);" onClick={() => onOpenDetail(record)}>查看</a>
    //     </Fragment>
    //   }
    // }
  ];

  const columnsCombo = [
    {
      key: 'productCategoryName',
      title: '套餐类别',
      width: 100,
      ellipsis: true,
      render: (_, record) => (record.categories || []).map(_ => _.name).join("/")
    },
    {
      dataIndex: 'name',
      title: '套餐名称',
    },
    {
      dataIndex: 'price',
      title: '价格',
      width: 50,
    },
    {
      dataIndex: 'description',
      title: '描述',
      width: 120,
      ellipsis: true
    },
  ]

  const rowSelection = {
    selectedRowKeys,
    onChange: (nextSelectedRowKeys, nextSelectedRows) => {
      setSelectedRowKeys(nextSelectedRowKeys);
      // console.log(nextSelectedRowKeys, nextSelectedRows)
      setProducts(nextSelectedRows[0].orderTemplateVos[0].orderItemTemplateVos)
      // setSelectedRows(prevSelectedRows => {
      //   // 找出不属于当前页选中的商品
      //   const notCurrantPageRows = prevSelectedRows.filter(product => products.findIndex(_ => _.id === product.id) < 0);

      //   return [...notCurrantPageRows, ...nextSelectedRows];
      // });
    },
  };

  return (
    <Modal
      className={styles.productModal}
      {...modalProps}
      okButtonProps={{ disabled: !products.length }}
      onOk={handleOk}
    >
      <Row>
        <Search
          enterButton
          style={{ width: 200, marginRight: 20 }} placeholder="商品名称模糊搜索"
          onSearch={handleSearchName}
        />
        <ProductCategoryTreeSelect
          productCategories={productCategories}
          value={category}
          onChange={handleCategoryChange}
          style={{ width: 200 }}
        />
      </Row>
      <div className='select-zone'>
        <div className='combo-table'>
          <Table
            size='small'
            columns={columnsCombo}
            dataSource={combo}
            rowKey='id'
            rowSelection={{
              type: 'radio',
              ...rowSelection,
            }}
            // rowSelection={rowSelection}
          />
        </div>
        <div className='product-table'>
          <Table
            size='small'
            columns={columns}
            dataSource={products}
            rowKey='id'
            // rowSelection={rowSelection}
            // pagination={{
            //   ...pagination,
            //   onChange: handlePageChange
            // }}
            pagination={false}
            loading={loading}
          />
        </div>
        {/* <div className='select-rows'>
            <div className='select-rows-label'>已选择的商品({selectedRows.length})</div>
            <div className='select-rows-content'>
              {selectedRows.map(row => (
                <Tag
                  closable
                  className='selected-row'
                  onClose={() => handleRemove(row)}
                >{row.name}</Tag>
              ))}
            </div>
          </div> */}
      </div>
    </Modal>
  )
}
export default ProductModal
